/* noinspection CssUnresolvedCustomProperty */
.list {
  gap: 1px;
}

/* noinspection CssUnresolvedCustomProperty */
.tab {
  min-height: 36px;
  border-radius: 0;
  background-color: light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-6));
  color: light-dark(var(--mantine-color-text-4), var(--mantine-color-gray-4));
  border: 1px solid transparent;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  font-weight: 400;
  text-align: center;
  flex: 1;
  padding: 4px 2px;
}

/* noinspection CssUnresolvedCustomProperty */
.tab[data-active] {
  background-color: light-dark(var(--mantine-color-brand-2), var(--mantine-color-brand-8));
  color: light-dark(var(--mantine-color-brand-7), var(--mantine-color-brand-4));
  border-color: transparent;
  font-weight: 600;
}

.tabSection {
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  width: 100%;
}

.tabLabel {
  font-size: 10px;
  line-height: 1;
  font-weight: inherit;
  text-align: center;
  white-space: nowrap;
  display: none;
  width: 100%;
}

.tooltip {
  flex: 1;
}

@media (min-width: 30em) {
  .tab {
    gap: 4px;
    padding: 6px 4px;
  }

  .tabLabel {
    display: block;
    margin-top: 2px;
  }
}

/* noinspection CssUnresolvedCustomProperty */
.panel {
  padding-top: var(--mantine-spacing-sm);
}
